package com.hyperether.planner.model

data class DashboardPlan(
    val time: String,
    val events: List<Event>?
)